<script setup lang="ts">
import LoadButton from "~/components/Common/Buttons/LoadButton.vue";
import { useLearningPathTrainingsStore } from "~/store/learning-path/learning-path-trainings.store";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const { handleLearningPathTrainingsSessionsModal, confirmAttendeesToSession } = useLearningPathTrainingsStore();
const { sessionsDatas, trainingsDatas, currentTrainingPathId } = storeToRefs(useLearningPathTrainingsStore());
const load = ref(false);
const selectedSessions = computed(() => sessionsDatas.value?.find((session: any) => session.isCheck)?.sessionId);
const isOnDemand = computed(() =>
  trainingsDatas.value?.find(
    (training: any) => training.learningPathTrainingId === currentTrainingPathId.value && training.isOnDemand,
  ),
);
async function registerAttendees() {
  await confirmAttendeesToSession(isOnDemand.value ? null : selectedSessions.value);
}

const disabled = computed(() => {
  if (isOnDemand.value) {
    return false;
  }
  return !selectedSessions.value;
});
</script>

<template>
  <div class="body_med flex w-full">
    <footer class="training-course-footer">
      <div class="flex w-full justify-between px-6 gap-3">
        <AppButton
          type="outlined"
          label="Retour"
          class="w-full"
          @click="handleLearningPathTrainingsSessionsModal(false)"
        />
        <LoadButton
          v-model="load"
          class="button__default w-full"
          :text-confirm="'Inscrire les participants'"
          :disabled="disabled"
          @click="registerAttendees()"
        >
        </LoadButton>
      </div>
    </footer>
  </div>
</template>

<style scoped lang="scss">
.training-course-footer {
  @apply flex w-full items-center gap-5 justify-end py-4;
  border-top: 1px solid var(--grey-lightest);
}
</style>
